import Vue from 'vue'

const getDefaultState = () => {
    return {
        class: {
            id: 0,
            description: ""
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("quickbooks/class/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listClass = result.data.result;

                return listClass;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list class: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.class, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.class;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
